<template>
  <v-container>
    <v-row>
      <v-col sm="10">
        <h4 class="white--text">Latest updates</h4>
      </v-col>
      <v-col sm="2">
        <div
          :class="{ paddingT10: commentsToggle }"
          @click="commentsToggle = !commentsToggle"
        >
          <v-icon
            class="cursorPointer"
            color="white"
            size="25"
            v-if="!commentsToggle"
            :data-test-id="`${dataTestId}__open-icon`"
            >add</v-icon
          >
          <v-icon
            class="cursorPointer"
            color="white"
            size="25"
            v-if="commentsToggle"
            :data-test-id="`${dataTestId}__close-icon`"
            >maximize</v-icon
          >
        </div>
      </v-col>
    </v-row>
    <transition name="slideUp">
      <div v-if="commentsToggle">
        <ul class="latest-list" :data-test-id="`${dataTestId}__comment-list`">
          <li
            v-for="(item, index) in allComments"
            :key="index"
            class="cursorPointer"
            @click="gotoArchive(item)"
            :data-test-id="`${dataTestId}__comment-list-item-${index+1}`"
          >
            <v-avatar :size="36" color="#58e2c2" class="mt-2 mr-2">
              <span class="white--text subheading">{{
                getUserNameInitials(formatUserName(allUserObj[item.userId]))
              }}</span>
            </v-avatar>
            <div class="data overflow-hidden">
              <p class="date">
                {{ getFormatedDateAsPerTimeAndDate(item.createdAt) }}
              </p>
              <p class="email">
                {{ formatUserName(allUserObj[item.userId]) }}
              </p>
              <p
                class="text truncate-line"
                :inner-html.prop="renderDecodedComment(item.comment) | sanitize"
              ></p>
            </div>
          </li>
        </ul>
        <span v-if="!allComments.length">No comments on this project</span>
      </div>
    </transition>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      commentsToggle: true
    };
  },
  props: {
    projectDetails: Object,
    allComments: Array,
    allUserObj: Object,
    dataTestId:String
  },
  methods: {
    // TODO: Need to refactor this code
    gotoArchive(item) {
      let path = `/discovery/projects/${this.$route.params.projectId}/archive/`;
      const { archiveId, archiveType, itemId } = item;
      let queryParams;
      if (archiveType === this.$enums.archiveType.VAULT) {
        let sourceType = '';
        if (archiveId.includes('o365_onedrive')) {
          sourceType = 'o365_onedrive';
        } else if (archiveId.includes('o365_sharepoint')) {
          sourceType = 'o365_sharepoint';
        } else if (itemId.includes('dropbox')) {
          sourceType = 'dropbox';
        } else {
          sourceType = 'o365_teams';
        }
        queryParams = {
          archiveId,
          messageGroupId: itemId || ''
        };
        const connectorName = this.connectorArchiveNameMap(sourceType)?.id;
        path = `${path}vault/connector/${connectorName}/${encodeURIComponent(
          archiveId
        )}`;
      } else {
        path = `${path}${encodeURIComponent(
          archiveId
        )}/attachment/${item.attachmentId || 0}`;
      }
      this.$router.push({
        path,
        query: queryParams
      });
    }
  },
  mounted() {
    let all = this.allComments.map(comment => comment.userId);
    all = [...new Set(all)];
    if (all.length) {
      this.addUserDetails([...all]);
    }
  }
};
</script>

<style>
.latest-list {
  list-style: none;
  padding: 0 !important;
  width: 100%;
  margin-left: 0;
}

.latest-list li {
  padding: 10px !important;
  background: white;
  margin-bottom: 10px;
  display: flex;
  vertical-align: middle;
}

.latest-list li .image {
  width: 30%;
  text-align: center;
}

.latest-list li img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.latest-list li .data {
  text-align: center;
  /* display: inline-block; */
  /* overflow: hidden; */
  margin-top: 14px;
}

.latest-list li .data p {
  /* margin: 5px !important; */
  margin-bottom: 8px;
}

.latest-list li .data .date {
  color: #58e2c2;
  margin-bottom: 4px;
  font-size: 10px;
  font-weight: 700;
  line-height: 10px;
  text-align: left;
}

.latest-list li .data .email {
  color: #1b2342;
  font-size: 12px;
  font-weight: 700;
  line-height: 12px;
  text-align: left;
}

.latest-list li .data .text {
  color: #1b2342;
  word-break: break-word;
  font-size: 14px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
  overflow: hidden;
  margin-bottom: 0;
}
</style>
